import { z } from "zod";
import { dmaUserSchema } from "../dma-user";
import { DmaFramework } from "./dma-framework.schema";
import { dmaReactionParticipantDtoSchema } from "./dma-reaction-participant.schema";
export const dmaReactionDtoSchema = z.object({
    id: z.number(),
    reactants: z.array(dmaReactionParticipantDtoSchema),
    products: z.array(dmaReactionParticipantDtoSchema),
    isEquilibrium: z.boolean(),
    equilibriumFormula: z.string(),
    equilibriumFormulaParameters: z.array(z.number()),
    activitiesFramework: z.nativeEnum(DmaFramework),
    tags: z.array(z.string()),
    updatedAt: z.string().datetime(),
    updatedBy: z.nullable(dmaUserSchema),
});
